import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  fetchAttachmentsAndAppendToModule,
  fetchCampaignsAndAppendToModule,
  fetchDataAndUpdateStore,
  fetchDetailAndAppendToModule,
  fetchEmailAndAppendToModule,
  fetchNotesAndAppendToModule,
  fetchTagsAndAppendToModule,
} from '../../redux/actions';
import { getContactById, getContactList, getGridDataByModuleKey } from '../../redux/selector';
import ContactForm from './contactForm';
import { useDispatch, useSelector } from 'react-redux';
import Notes from '../sharedChild/note/notes';
import Attachments from '../sharedChild/attachment/attachments';
import Email from '../sharedChild/email/emails';
import ChildCampaign from '../sharedChild/childCampaign';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import Loader from '../../shared/component/Loader';
import ComposeEmail from '../sharedChild/email/compose';
import Timeline from '../sharedChild/timeline';
import ChildDeal from '../sharedChild/childDeal';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { contactInputData } from '../../shared/constants';
import aiImage from '../../../src/assets/img/crm_home/header/ai.png';
import Enrichment from '../leads/leadEnrichment';
import edit from '../../../src/assets/img/crm_home/header/edit.png';
import send from '../../../src/assets/img/crm_home/header/send.png';
import addNote from '../../../src/assets/img/crm_home/header/addNote.png';

const validationSchema = Yup.object().shape({
  businessType: Yup.string().required('Business Type is required'),
  industry: Yup.string().required('Industry is required'),
});
const ViewContact = ({}) => {
  const [activeTab, setActiveTab] = useState('overview');
  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
    campaigns: useRef(null),
    opportunities: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'contactList');
  const [formData, setFormData] = useState({});
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [loading, setLoading] = useState(storeLoading);
  const [sentData, setSentData] = useState([]);
  const [draftData, setDraftData] = useState([]);
  const [scheduledData, setScheduledData] = useState([]);
  const [showPopup5, setShowPopup5] = useState(false);
  const [opportunityByModule, setOpportunityByModule] = useState({});
  const [enrichedDataLoading, setEnrichedDataLoading] = useState(false);
  const [showPopupConatct, setShowPopupContact] = useState(false);
  const [conatctEnrichedData, setContactEnrichedData] = useState();
  const [isEnrichedFlag, setIsEnrichedFlag] = useState(false);
  const [refreshView, setRefreshView] = useState(false);
  const contactList = useSelector(getContactList);
  const gridData = useSelector(getGridDataByModuleKey('contactList'));

  const searchParams = new URLSearchParams(location.search);
  const contactID = searchParams.get('id');

  let hasUpdateOpportunityPermission = true;
  let hasViewOpportunityPermission = true;
  let hasUpdateCampaignPermission = true;
  let hasViewCampaignPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.campaignmenu;
  let userUIControlPermissionOpportunity = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.opportunitymenu;

  if (userUIControlPermission) {
    hasViewCampaignPermission = userUIControlPermission?.campaignviewscreen
      ? userUIControlPermission.campaignviewscreen.canView
      : true;

    hasUpdateCampaignPermission = userUIControlPermission?.campaignupdatescreen
      ? userUIControlPermission.campaignupdatescreen.canView
      : true;
  }
  if (userUIControlPermissionOpportunity) {
    hasViewOpportunityPermission = userUIControlPermissionOpportunity?.opportunityviewscreen
      ? userUIControlPermissionOpportunity.opportunityviewscreen.canView
      : true;

    hasUpdateOpportunityPermission = userUIControlPermissionOpportunity?.opportunityupdatescreen
      ? userUIControlPermissionOpportunity.opportunityupdatescreen.canView
      : true;
  }

  // const contactLocalData = useSelector((state) => {
  //   const contactId = location.state?.id || contactID;
  //   return getContactById(state, contactId);
  // });
  const [contactLocalData, setContactLocalData] = useState(location.state || {});
  const contactStoreData = useSelector((state) => {
    const contactId = location.state?.id || contactID; // Use the pre-fetched `leadID`
    return getContactById(state, contactId);
  });

  useEffect(() => {
    setContactLocalData((prev) => ({ ...prev, ...contactStoreData }));
  }, [contactStoreData]);

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    if (name === 'revenueTypeId') {
      setFormData({
        ...formData,
        revenueTypeId: selectedId,
        revenueType: selectedValue,
      });

      setFormEdited(true);
    } else if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'industryId') {
      setFormData({
        ...formData,
        industryId: selectedId,
        industry: selectedValue,
      });
      setFormEdited(true);
    }
  };
  const handleSubmit = async (formData) => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  const openPopup5 = () => {
    setShowPopup5(true);
  };
  const closePopup5 = () => {
    setShowPopup5(false);
  };

  const handleOpenEditForm = (paramsValue) => {
    navigate('/contacts/editContact', {
      state: formData,
    });
  };

  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  // Function to open the fifth popup
  const openPopupContact = () => {
    setShowPopupContact(true);
  };

  const closePopupContact = () => {
    setShowPopupContact(false);
  };

  const handleClickDataEnrichment = (paramsValue) => {
    if (contactLocalData.firstName === '' || contactLocalData.lastName === '') {
      toast.error('Please fill in the first name and last name fields.', {
        position: 'top-right',
      });
      return;
    }
    setEnrichedDataLoading(true);
    const data = {
      LeadName: `${contactLocalData?.fullName}`,
      CompanyName: `${contactLocalData?.account}`,
      EnrichmentType: 'contacts',
    };

    const fetchEnrichedData = () => {
      apiServices
        .getEnrichedData(data)
        .then((response) => {
          if (response.status === 200) {
            setContactEnrichedData(response.data?.enriched_data);
            setEnrichedDataLoading(false);
            openPopupContact();
            apiServices
              .updateEnrichedFlag(
                {
                  id: contactLocalData.id,
                },
                'contact'
              )
              .then((res) => {
                if (res.status === 200) {
                  if (res.status === 200) {
                    setIsEnrichedFlag(true); // Set the enriched flag to true
                  }
                }
              })
              .catch((error) => {
                console.error('Error updating enriched flag:', error);
                toast.error('Failed to update enriched flag.', {
                  position: 'top-right',
                });
              });
          } else if (response.status === 202) {
            toast.info('Enrichment Initiated! Retrying in 2 minutes...', {
              position: 'top-right',
            });
            setTimeout(fetchEnrichedData, 120000); // Retry after 2 minutes
          }
        })
        .catch((error) => {
          console.error('Error while fetching enriched data:', error);

          // Safely extract error message from response
          const errorMsg = error?.response?.data?.error || 'An unexpected error occurred.';

          toast.error(errorMsg, {
            position: 'top-right',
          });

          setEnrichedDataLoading(false);
        });
    };

    fetchEnrichedData();
  };

  const handleUpdateForm = async (formData) => {
    setLoading(true);
    try {
      const response = await apiServices.updateContactList(formData);
      if (response.status === 200) {
        await dispatch(
          fetchDataAndUpdateStore({
            key: 'contactList',
            inputData: gridData?.inputPayload ? gridData?.inputPayload : contactInputData,
          })
        );
        setShowPopup5(false);
        closePopupContact();
        setRefreshView((prev) => !prev);
      } else {
        setLoading(false);
        const errorMessages = [];
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            const messages = response.errors[key];
            errorMessages.push(...messages);
          }
        }
        errorMessages.forEach((errorMessage) => {
          toast.error(errorMessage, { position: 'top-right' });
        });
      }
    } catch (error) {
      console.error('Error:', error, 'DataFormat:', formData);
      toast.error('An unexpected error occurred.', {
        position: 'top-right',
      });
      setLoading(false);
    }
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '-200px 0px 0% 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    // Cleanup on unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    const data = { moduleName: 'Contact', id: contactLocalData?.id };
    apiServices
      .getOpportunityByModule(data)
      .then((response) => {
        if (response.status === 200) {
          const opportunityList = response.data;
          setOpportunityByModule(opportunityList);
          setLoading(false);
        } else {
          console.error('Error fetching user timelog settings:', response?.status);
        }
      })
      .catch((error) => {
        console.error('Error fetching user timelog settings:', error);
      });
  }, []);

  useEffect(() => {
    if (contactLocalData?.emails) {
      const { sent, draft, scheduled } = contactLocalData?.emails?.reduce(
        (acc, item) => {
          if (item.status === 'Sent') acc.sent.push(item);
          else if (item.status === 'Draft') acc.draft.push(item);
          else if (item.status === 'Scheduled') acc.scheduled.push(item);
          return acc;
        },
        { sent: [], draft: [], scheduled: [] }
      );

      setSentData(sent);
      setDraftData(draft);
      setScheduledData(scheduled);
    }
    if (contactLocalData?.isEnriched) {
      setIsEnrichedFlag(contactLocalData?.isEnriched);
    }
  }, [contactLocalData]);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    const contactId = location.state?.id || contactID;
    if (location.pathname.includes('viewContact')) {
      setFormData({
        ...contactLocalData,
        type: 'view',
        from: 'view',
      });
    }
    if (contactId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Contact',
          id: contactId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Contact',
          id: contactId,
        })
      );
      dispatch(
        fetchAttachmentsAndAppendToModule({
          moduleName: 'Contact',
          id: contactId,
        })
      );
      dispatch(
        fetchCampaignsAndAppendToModule({
          moduleName: 'Contact',
          id: contactId,
        })
      );
      dispatch(
        fetchEmailAndAppendToModule({
          moduleName: 'Contact',
          id: contactId,
        })
      );
      dispatch(
        fetchTagsAndAppendToModule({
          moduleName: 'Contact',
          id: contactId,
        })
      );
    }
  }, [location, contactLocalData?.id, refreshView]);

  return (
    <>
      {loading && <Loader />}
      <div className="ViewLeadPageOuter">
        <div className="viewHeader">
          <HeaderProfileBlock localData={contactLocalData} moduleName={'Contact'} View={true} />
          <div className="rightActionDskButton">
            <div className="rightAction">
              {contactLocalData?.isEnriched === true || isEnrichedFlag ? (
                <button
                  className="btn btn-outline-primary me-3"
                  onClick={handleClickDataEnrichment}
                >
                  {enrichedDataLoading && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {enrichedDataLoading ? 'Loading...' : 'Refresh Enriched Data'}
                </button>
              ) : (
                <button
                  className="btn btn-outline-primary d-flex align-items-center"
                  onClick={handleClickDataEnrichment}
                  disabled={enrichedDataLoading} // Disable button when loading
                >
                  {enrichedDataLoading && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}

                  {enrichedDataLoading ? (
                    'Loading...'
                  ) : (
                    <>
                      <img
                        src={aiImage}
                        alt="AI Icon"
                        className="me-2"
                        style={{ width: '16px', height: '16px' }}
                      />
                      Get Enriched Data{' '}
                    </>
                  )}
                </button>
              )}

              <button
                className="btn btn-outline-primary"
                onClick={handleOpenEditForm}
                disabled={!formData}
              >
                <img
                  src={edit}
                  alt="Edit"
                  className="me-2"
                  style={{ width: '12px', height: '12px' }}
                />
                <span className="btnText"> Edit</span>
              </button>
              <button
                className="btn btn-outline-primary actbtn sendEmailBtn"
                onClick={openPopup5}
                disabled={contactLocalData?.emailOptOut === true}
              >
                <img
                  src={send}
                  alt="Send"
                  className="me-2"
                  style={{ width: '14px', height: '14px' }}
                />
                <span className="btnText"> Send Email</span>
              </button>

              <div id="sendmail">
                {showPopup5 && (
                  <ComposeEmail
                    localData={contactLocalData}
                    module={'Contact'}
                    handleClose={closePopup5}
                    handleChange={handleChange}
                  />
                )}
              </div>
            </div>

            <div className="mob">
              <div className="adnoteMob ms-2">
                <button
                  className="btn btn-primary"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasExample"
                  aria-controls="offcanvasExample"
                >
                  <img
                    src={addNote}
                    alt="Add a Note"
                    className="me-2"
                    style={{ width: '12px', height: 'auto' }}
                  />
                  <span className="btnText">Add a Note</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="detailContainer">
          <div className="viewFormContainer">
            <div className="leftBlock">
              <ul>
                {Object.keys(refs).map((key) => (
                  <li
                    key={key}
                    onClick={() => scrollToSection(key)}
                    style={{ cursor: 'pointer' }}
                    className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                  >
                    <button onClick={() => setActiveTab(key)}>
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                      {['openActivities', 'closedActivities', 'invitedMeetings'].includes(key) && (
                        <span style={{ fontSize: '7px', fontWeight: '600' }}> (Coming Soon)</span>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rightBlock" id="detailPageRight">
              <div className="addlead_container">
                <Formik
                  initialValues={formData}
                  onSubmit={(values) => handleSubmit(values)}
                  validationSchema={validationSchema}
                >
                  <Form>
                    <div className="tab-content">
                      <div id="overview" className="scrollTo" ref={refs.overview}></div>
                      {formData && (
                        <ContactForm formData={formData} selectedOptions={selectedOptions} />
                      )}
                      <div id="attachments" className="scrollTo" ref={refs.attachments}></div>
                      <Attachments localData={contactLocalData} module={'Contact'} />
                      {hasViewCampaignPermission && (
                        <>
                          <div id="campaigns" className="scrollTo" ref={refs.campaigns}></div>
                          <ChildCampaign
                            localData={contactLocalData}
                            module={'Contact'}
                            hasUpdateCampaignPermission={hasUpdateCampaignPermission}
                          />
                        </>
                      )}
                      {hasViewOpportunityPermission && (
                        <>
                          <div
                            id="opportunities"
                            className="scrollTo"
                            ref={refs.opportunities}
                          ></div>
                          <ChildDeal
                            localData={opportunityByModule}
                            module={'Contact'}
                            hasUpdateOpportunityPermission={hasUpdateOpportunityPermission}
                          />
                        </>
                      )}

                      <div id="emails" className="scrollTo" ref={refs.emails}></div>
                      <Email localData={contactLocalData} module={'Contact'} />
                    </div>
                    <div id="timeline" className="scrollTo" ref={refs.timeline}></div>

                    <Timeline localData={contactLocalData} module={'Contact'} />
                  </Form>
                </Formik>
              </div>
            </div>
          </div>
          <div className="viewFormNotesOuter">
            <div className="ViewFormNotesContainer">
              <Formik
                initialValues={formData}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validationSchema}
              >
                <Form>
                  <div id="notes" className="scrollTo" ref={refs.notes}></div>
                  <Notes leadLocalData={contactLocalData} module={'Contact'} />
                </Form>
              </Formik>
            </div>
          </div>
        </div>
        <div
          className="offcanvas addNoteMobBlock offcanvas-end"
          tabindex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasExampleLabel">
              <img src="../assets/images/notesIcon.svg" alt="Note" width="16px" />
              Notes
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="ViewFormNotesContainer">
              <Formik initialValues={formData} validationSchema={validationSchema}>
                <Form id="viewForm">
                  <Notes leadLocalData={contactLocalData} module={'Contact'}></Notes>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {showPopupConatct && (
        <Enrichment
          handleClose={closePopupContact}
          localData={contactLocalData}
          enrichedData={conatctEnrichedData}
          handleSave={handleUpdateForm}
          loading={loading}
        />
      )}
    </>
  );
};
export default ViewContact;
